if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        const selectedVariantId = parseInt(formData.get('id'), 10);

        const isB2BValid = this.validateB2B(selectedVariantId);

        if (!isB2BValid) {
          alert(`You do not have permission to add this product to the cart.`);
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          return;
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const customOptionsForm = document.getElementById('product-options__form')
        if (customOptionsForm) {
          const isCustomOptionsFormValid = this.validateCustomOptionsForm(customOptionsForm);

          if (!isCustomOptionsFormValid) {
            // Open the accordion if it's closed
            const accordionDetails = customOptionsForm.closest('details');
            if (accordionDetails && !accordionDetails.hasAttribute('open')) {
              accordionDetails.setAttribute('open', '');
              // Scroll to accordion with smooth behavior
              setTimeout(() => {
                accordionDetails.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
              }, 100);
            }
            alert('Please fill all required fields');
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            return;
          }

          const formCustomOptionsData = new FormData(customOptionsForm);
          for (let [key, value] of formCustomOptionsData.entries()) {
            formData.append('properties[' + key + ']', value);
          }
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              const productErrorContainer = document.querySelector('.product-form__error-message-wrapper');
              const productError = document.querySelector('.product-form__error-message');
                 if (response.status === 422 ) {
                   productErrorContainer.style.display = 'flex';
                   productError.innerText = response.description
                   setTimeout(function() {
                     productErrorContainer.style.display = 'none';
                   }, 3000);
                }

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
              
              const variantId = parseInt(formData.get('id')); // Convert to number for consistency
              const quantity = parseInt(formData.get('quantity')) || 1;
              const productId = response?.items?.[0]?.product_id || null;
              
              // Track add to cart event
              if (typeof window.trackEvent === 'function') {
                window.trackEvent('Add To Cart', 'WEBSITE: Added product to cart', {
                  product_id: productId,
                  quantity: quantity,
                  variant_id: variantId,
                  source: 'website'
                });
              }
            }
            document.dispatchEvent(new Event('cart:updated'));
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      validateCustomOptionsForm(customOptionsForm) {
        const requiredFields = customOptionsForm.querySelectorAll('[required]');
        const radioGroups = {};
        let formIsValid = true;

        requiredFields.forEach(field => {

          if (field.type === 'radio') {
            if (!radioGroups[field.name]) {
              radioGroups[field.name] = false;
            }
            if (field.checked) {
              radioGroups[field.name] = true;
            }
          } else if (field.type === 'checkbox') {
            if (!field.checked) {
              formIsValid = false;
            }
          } else if (field.tagName === 'SELECT') {
            if (field.value === '' || field.value === field.options[0].value) {
              formIsValid = false;
            }
          } else if (field.tagName === 'TEXTAREA' || field.type === 'text' || field.type === 'email' || field.type === 'password') {
            if (!field.value.trim()) {
              formIsValid = false;
            }
          }
        });
        for (const group in radioGroups) {
          if (!radioGroups[group]) {
            formIsValid = false;
          }
        }
        return formIsValid
      }

      validateB2B(selectedVariantId) {
        var allowedVariantIds = window.myProducts || [];
        var isOrderingOnly = window.isOrderingOnly;

        if (isOrderingOnly) {
          if (!allowedVariantIds.includes(selectedVariantId)) {
            return false;
          }
        }
        return true;
      }
    }
  );
}
